import * as React from 'react';
import { userAsPromise } from '../../data/providers/userProvider';
import { IUser } from '../../data/types';
import { Icon } from '../shared/Icon';
import { Image } from '../shared/Image';

interface IProps {
  alt?: string;
  src?: string;
  imageToken?: string;
  size: 'x-large' | 'large' | 'medium' | 'small' | 'list-avatar';
  style?: React.CSSProperties;
  onClick?: () => void;
  inverse?: boolean;
  pdf?: boolean;
}

const baseStyle = {
  borderRadius: '50%',
  backgroundColor: 'var(--color-avatar-background)',
};

const Avatar = (props: IProps): React.ReactElement => {
  const [imageUrl, setImageUrl] = React.useState<string>();

  React.useEffect((): void => {
    if (!props?.src && !props?.imageToken) return;

    if (props.imageToken) {
      userAsPromise()
        .then((user: IUser): Promise<Blob> => {
          return user.services.getGCSImage(props.imageToken);
        })
        .then((blob: Blob): void => {
          setImageUrl(URL.createObjectURL(blob));
        })

        // eslint-disable-next-line no-console
        .catch((err: unknown): void => console.error(err));
    } else {
      if (props.pdf) {
        toDataUrl(props.src, setImageUrl);
      } else {
        setImageUrl(props.src);
      }
    }
  }, [props?.src, props?.pdf]);

  const { src, size } = props;
  return src && src.length > 0 ? (
    <Image
      title={props.alt}
      alt={`${props.alt} Avatar`}
      size={size}
      src={imageUrl}
      style={{ ...baseStyle, ...props.style }}
      onClick={props.onClick}
    />
  ) : (
    <Icon
      title={props.alt}
      alt={`${props.alt} Avatar`}
      size={size}
      name='account_circle'
      style={{ ...baseStyle, ...props.style }}
      inverse={props.inverse}
      onClick={props.onClick}
    />
  );
};

export { Avatar };

const hasProtocol = (src: string): boolean => /^https?:\/\//i.test(src);

/**
 * @description creates data URL
 * @param url
 * @param callback
 */
const toDataUrl = (url: string, callback?: (file: string) => void): void => {
  const xhr = new XMLHttpRequest();
  xhr.onload = (): void => {
    const reader = new FileReader();
    if (callback) {
      reader.onloadend = (): void => {
        callback(reader.result as string);
      };
    }

    reader.readAsDataURL(xhr.response);
  };
  xhr.open('GET', url);
  xhr.responseType = 'blob';
  xhr.send();
};
